import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { INITIAL_DETAILS, INITIAL_PERMISSION } from './consts';
import { setUserDetails, reset, setPermission, setLoading } from './actions';

const detailsReducer = handleActions(
  {
    [setUserDetails.toString()]: (_, { payload: basicInfo }) => basicInfo,
    [reset.toString()]: () => INITIAL_DETAILS
  },
  INITIAL_DETAILS
);

const permissionReducer = handleActions(
  {
    [setPermission.toString()]: (_, { payload: permission }) => {
      return {
        ...INITIAL_PERMISSION,
        ...permission
      };
    }
  },
  INITIAL_PERMISSION
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload: loading }) => loading,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  details: detailsReducer,
  permission: permissionReducer,
  loading: loadingReducer
});
